import {createReducer, on} from '@ngrx/store';
import * as TaxonomyActions from './taxonomy.actions';

export const taxonomyMaxLevel = 2;
export const taxonomyFeatureKey = 'taxonomy';

export interface Taxonomy {
  id: number;
  name: string;
  level: number;
  parent?: Taxonomy;
  children: Taxonomy[];
}

export interface TaxonomyState {
  taxonomies: Taxonomy[];
  filteredTaxonomies: Taxonomy[];
}

export const initialState: TaxonomyState = {taxonomies: [], filteredTaxonomies: []};

export const taxonomyReducer = createReducer(
  initialState,
  on(TaxonomyActions.loadAllTaxonomiesSuccess, (state, action) => ({...state, taxonomies: action.data})),
  on(TaxonomyActions.loadFilteredTaxonomiesSuccess, (state, action) => ({...state, filteredTaxonomies: action.data})),
);
